import React, { forwardRef } from "react";
import { useQuery } from "@apollo/react-hooks";

import "./desktop-new-products-style.scss";
import useIsComDomain from "@src/hooks/useIsComDomain";

import DesktopProductListSkeleton from "@src/componentsNew/Skeleton/desktop/components/DesktopProductListSkeleton";
import ProductListTitle from "@src/componentsNew/ProductListTitle/ProductListTitle";
import VerticalProductThumbnail from "@src/componentsNew/ProductThumbnail/VerticalProductThumbnail/VerticalProductThumbnail";
import { newProducts } from "@organisms/NewProducts/__generated__/newProducts";
import { NEW_PRODUCT_LIST } from "@organisms/NewProducts/queries";

const DesktopNewProducts = forwardRef<HTMLDivElement>((_, ref) => {
  const isComDomain = useIsComDomain();

  const { data, loading } = useQuery<newProducts>(NEW_PRODUCT_LIST, {
    fetchPolicy: "network-only",
    variables: {
      first: isComDomain ? 12 : 18,
      isMgs: isComDomain ? true : false
    },
  });

  if (loading) {
    return (
      <DesktopProductListSkeleton
        type="horizontal"
        count={isComDomain ? 12 : 18}
        hasTitle={true}
      />
    );
  }

  return (
    data && data.products.totalCount > 0 ? (
      <div className="desktop-new-products-wrapper" ref={ref}>
        <ProductListTitle title={"New Arrivals"} typoVariant="h6" typoComponent="h6" />

        <div className="desktop-new-products-thumbnails-wrapper">
          {
            data.products.edges.map((item, idx) =>
              <VerticalProductThumbnail key={idx} product={item.node} isVerticalOne={true} />
            )
          }
        </div>
      </div>
    ) : null
  );
});

export default DesktopNewProducts;
